// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media all and (min-width: 1280px) {
  .carousel {
    display: flex;
    grid-gap: 2rem;
    align-items: center;
  }
}
.carousel__swiper {
  flex-grow: 1;
  margin-left: -1rem;
  width: calc(100% + 2rem);
}
@media all and (min-width: 1280px) {
  .carousel__swiper {
    width: 100%;
    margin-left: 0;
  }
}
.carousel__prev, .carousel__next {
  display: none;
}
@media all and (min-width: 1280px) {
  .carousel__prev, .carousel__next {
    display: block;
    height: fit-content;
    transition: 250ms;
  }
}
@media all and (hover: hover) {
  .carousel__prev, .carousel__next {
    cursor: pointer;
  }
  .carousel__prev:hover, .carousel__next:hover {
    opacity: 0.5;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Carousel/Carousel.scss"],"names":[],"mappings":"AAIE;EAFF;IAGI,aAAA;IACA,cAAA;IACA,mBAAA;EAFF;AACF;AAIE;EACE,YAAA;EACA,kBAAA;EACA,wBAAA;AAFJ;AAII;EALF;IAMI,WAAA;IACA,cAAA;EADJ;AACF;AAIE;EAEE,aAAA;AAHJ;AAKI;EAJF;IAKI,cAAA;IACA,mBAAA;IACA,iBAAA;EAFJ;AACF;AAII;EAVF;IAWI,eAAA;EADJ;EAGI;IACE,YAAA;EADN;AACF","sourcesContent":["@import 'src/styles/variables';\n\n.carousel {\n\n  @media all and (min-width: $desktop) {\n    display: flex;\n    grid-gap: 2rem;\n    align-items: center;\n  }\n\n  &__swiper {\n    flex-grow: 1;\n    margin-left: -1rem;\n    width: calc(100% + 2rem);\n\n    @media all and (min-width: $desktop) {\n      width: 100%;\n      margin-left: 0;\n    }\n  }\n\n  &__prev,\n  &__next {\n    display: none;\n\n    @media all and (min-width: $desktop) {\n      display: block;\n      height: fit-content;\n      transition: 250ms;\n    }\n\n    @media all and (hover: hover) {\n      cursor: pointer;\n\n      &:hover {\n        opacity: 0.5;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
